import { render, staticRenderFns } from "./homeworkTecDetail.vue?vue&type=template&id=09db744f&scoped=true&"
import script from "./homeworkTecDetail.vue?vue&type=script&lang=js&"
export * from "./homeworkTecDetail.vue?vue&type=script&lang=js&"
import style0 from "./homeworkTecDetail.vue?vue&type=style&index=0&id=09db744f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09db744f",
  null
  
)

export default component.exports